export const ROLE_LIST_START = 'ROLE_LIST_START';
export const ROLE_LIST_SUCCESS = 'ROLE_LIST_SUCCESS';
export const ROLE_LIST_FAIL = 'ROLE_LIST_FAIL';
